const minHeight = typeof window !== 'undefined' && window.innerHeight
const minWidth = typeof window !== 'undefined' && window.innerWidth

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    display: 'block',
    minWidth: minWidth / 2
  },
  block: {
    display: 'block'
  },
  modal: {
    minHeight: 300,
    minWidth: 400,
    maxWidth: minWidth / 1.5
  },
  modalHeader: {
    fontWeight: '400 !important',
    fontSize: '1.2rem !important',
  },
  modalContent: {
    fontWeight: '400 !important',
    fontSize: '1.0rem',
  },
  form: {
    height: 150,
    overflowY: 'auto',
    '& input': {
      whiteSpace: 'nowrap !important',
      overflow: 'hidden !important',
      textOverflow: 'ellipsis !important',
    },
  },
  button: {
    marginLeft: theme.spacing.unit * 2
  },
  submit: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: 'white',
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622'
    }
  },
  close: {
    padding: 0,
    minWidth: 40,
  },
  flex: {
    flex: 1
  },
  scrollableList: {
    maxHeight: 100,
    overflow: 'auto'
  },
  summary: {
    padding: theme.spacing.unit
  },
  error: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f44336'
  },
  padded: {
    paddingLeft: 10
  },

})

export default styles
